export default __webpack_public_path__ + "c66578696369e07d8ffa49779612a7fc.png";